var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var BgaPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(BgaPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
BgaPadGeneratorInteractionModel.$class = 'BgaPadGeneratorInteractionModel';

module.exports = BgaPadGeneratorInteractionModel;

BgaPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.verticalPadCount = this.shadow("verticalPadCount",
        function() {
            return self.data.verticalPadCount();
        },
        function(value) {
            value = parseInt(value);
            
            //pad count should not be zero
            if(value === 0) return false;
            
            var status = self.data.verticalPadCount(value);
            self.updateNameList();
            return status;
        },
        [self.data.verticalPadCount]
    );

    this.horizontalPinPitch = this.shadow("horizontalPinPitch",
        function() {
            return self.data.horizontalPinPitch() / self.getUnitFactor();
        },
        function(value) {
            return self.data.horizontalPinPitch(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.horizontalPinPitch, this.userSettingsModel.distanceUnit
        ]
    );

    this.terminalType = this.shadow("terminalType",
        function() {
            return self.data.terminalType();
        },
        function(value) {
            return self.data.terminalType(value);
        },
        [self.data.terminalType]
    );
};

BgaPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalType = function() {
    var terminalTypeList = [];

    for(var i in cio_datamodel.IpcDataModel.ComponentAttribute.bgaTerminalType) {
        var t = cio_datamodel.IpcDataModel.ComponentAttribute.bgaTerminalType[i];
        terminalTypeList.push([this.LCLZ(i, t), t]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('terminalType', 'Terminal Type'), this.terminalType, terminalTypeList, this.showFootprintParams)];
};

BgaPadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    var rows = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#Rows', '# Rows'), this.horizontalPadCount);
    var cols = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#Cols', '# Cols'), this.verticalPadCount);

    return [rows, cols];
};

BgaPadGeneratorInteractionModel.prototype.getInspectorElementForPitch = function() {
    var rowPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('d', this.LCLZ('rowPitch', 'Row Pitch'), this.verticalPinPitch, this.userSettingsModel.distanceUnit);
    var colPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('e', this.LCLZ('colPitch', 'Col Pitch'), this.horizontalPinPitch, this.userSettingsModel.distanceUnit);

    return [rowPitch, colPitch];
};

BgaPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('ballDiameter', 'Ball Diameter'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit)];
};

BgaPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

BgaPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintBga));
        imElements = imElements.concat(this.getInspectorElementForPadDiameterInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForTerminalType());
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};